import { API_URL } from "env";
export interface ViewedProductAPIResponse {
    status: boolean;
    data: {
        total: number;
        current_page: number;
        items: Array<{
            id: number;
            customer_id: number;
            product_id: number;
            created_at: string;
            updated_at: string;
            product: {
                id: number;
                name: string;
                slug: string;
                avatar: string;
                alt: string | null;
                manufacturer_id: number;
                product_category_id: number;
                product_group_id: number | null;
                product_type_id: number | null;
                price: number;
                discount: number;
                content: string;
                ingredients: string;
                indications: string;
                contraindications: string;
                dosage: string;
                drug_interactions: string;
                storage: string;
                overdose: string;
                short_content: string | null;
                list_thumbnail: string | null;
                seo_page: string | null;
                translation: string | null;
                is_active: number;
                is_highlight: number;
                is_follow: number;
                is_new: number;
                is_limit: number;
                star: number;
                is_stock: number;
                position: number;
                point: number;
                created_at: string;
                updated_at: string;
                registration_number: string;
                active_ingredient: string;
                administration_route: string;
                packaging_spec: string;
                unit: string;
                vat: string;
                base_price: number;
                product_category: {
                    id: number;
                    name: string;
                    slug: string;
                };
                promotion: {
                    type: string;
                    percent: number;
                    detail: {
                        id: number;
                        name: string;
                        slug: string;
                        start_date: string;
                        end_date: string;
                        is_active: number;
                        created_at: string;
                        updated_at: string;
                    };
                } | null;
                discount_price: number | null;
            };
        }>;
    };
    msg: string;
}
async function fetchViewedProducts(sort: string = 'created_at,desc', limit: number = 10) : Promise<ViewedProductAPIResponse | null> {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    const query = new URLSearchParams();
    query.append('sort[]', sort);
    query.append('limit', String(limit));
    try {
        const response = await fetch(`${API_URL.replace(/\/$/, '')}/api/v1/fe/product_view?${query.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data: ViewedProductAPIResponse = await response.json();
        return data;
    }
    catch (error) {
        console.error("Failed to fetch viewed products:", error);
        return null;
    }
}

async function sendViewedProduct(productId: number) : Promise<ViewedProductAPIResponse | null> {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    try {
        const response = await fetch(`${API_URL.replace(/\/$/, '')}/api/v1/fe/product_view`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ product_id: productId }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error("Failed to send viewed product:", error);
        return null;
    }

}

export { fetchViewedProducts , sendViewedProduct };